import React from 'react';
import InputMask from '../InputMask';

const PercentageInput = ({ showSymbol = true, ...props }) => {
  return (
    <InputMask
      mask={function (rawValue) {
        const parsedValue = parseInt(rawValue.replace(/\D/g, ''));
        const maskArray = [];

        if (parsedValue == 100 || parsedValue % 100 == 0) {
          maskArray.push(...[/[1-9]/, /[0-9]/, /[0-9]/]);
        } else if (parsedValue < 10) {
          maskArray.push(...[/[0-9]/]);
        } else {
          maskArray.push(...[/[1-9]/, /[0-9]/]);
        }

        if (showSymbol) {
          maskArray.push(' %');
        }

        return maskArray;
      }}
      guide={false}
      {...props}
    />
  );
};

export default PercentageInput;
